import React, { useEffect, useState } from 'react';
import Checkbox from 'common/components/Checkbox';
import useFiltersStore from '../store/useFiltersStore';
import settings from '../util/config';
import { lotStatusFilterInputs } from '../util/filters';
import { getStatusColor } from '../util/polygon';
import { CHECKBOX_CHECKMARK_COLOR_DARK, CHECKBOX_CHECKMARK_COLOR_LIGHT, POLYGON_LOT_AVAILABLE_COLOR, POLYGON_LOT_MODEL_COLOR, POLYGON_LOT_MOVE_IN_READY_COLOR } from '../util/constants';
const LotStatusFilters = () => {
    const [lotStatusData, setLotStatusData] = useState(lotStatusFilterInputs);
    const { lotStatuses, setLotStatuses } = useFiltersStore();
    useEffect(() => {
        const lotStatusDataCopy = lotStatusData;
        lotStatusDataCopy.forEach((lotStatus) => {
            if (lotStatuses.includes(lotStatus.value)) {
                lotStatus.checked = true;
            }
            else {
                lotStatus.checked = false;
            }
        });
        setLotStatusData(lotStatusDataCopy);
    }, [lotStatuses]);
    function selectedTypesToArray() {
        return lotStatusData
            .filter((type) => type.checked)
            .map((type) => type.value);
    }
    function onSelect(homeTypeValue, checked) {
        // Update the checked value for the correct home type in the list
        const lotStatusDataCopy = lotStatusData;
        const updatedTypeIndex = lotStatusData.findIndex((home) => home.value === homeTypeValue);
        lotStatusDataCopy[updatedTypeIndex].checked = checked;
        setLotStatusData(lotStatusDataCopy);
        // set lot status array
        setLotStatuses(selectedTypesToArray());
    }
    return (React.createElement("fieldset", { className: 'viewport-maps__lot-status-filters' +
            (lotStatuses.length !== 0 ? ' viewport-maps__lot-status-filters--option-selected' : '') },
        React.createElement("legend", { className: "viewport-map__filters__heading" }, settings.FilterLotStatusLabel),
        lotStatusData.map((type, index) => {
            const inputColor = getStatusColor(type.value);
            // get accessible contrast color for checkmark pseudoelements
            let checkmarkColor;
            switch (inputColor) {
                case POLYGON_LOT_MODEL_COLOR:
                case POLYGON_LOT_MOVE_IN_READY_COLOR:
                case POLYGON_LOT_AVAILABLE_COLOR:
                    checkmarkColor = CHECKBOX_CHECKMARK_COLOR_DARK;
                    break;
                default:
                    checkmarkColor = CHECKBOX_CHECKMARK_COLOR_LIGHT;
            }
            return (React.createElement(Checkbox, { key: index, value: type.value, id: type.id, label: type.label, checked: lotStatuses.includes(type.value), onChange: (checked) => onSelect(type.value, checked), className: "viewport-maps__lot-status-filters__checkbox", style: {
                    '--checkbox-input-color': inputColor,
                    '--checkbox-checkmark-color': checkmarkColor
                } }));
        })));
};
export default LotStatusFilters;
